<template>
<div>
  <matter-add-matter-type-form ref="matterAddMatterTypeModal" :lawMatterId="lawMatterId" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-add-matter-type-form>
   <matter-smuggling-form ref="matterSmugglingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-smuggling-form>
   <matter-damages-claim-form ref="matterDamagesClaimFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-damages-claim-form>
   <matter-consulting-form ref="matterConsultingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-consulting-form>
   <matter-customs-registration-form ref="matterCustomsRegistrationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-customs-registration-form>
   <matter-stop-customs-form ref="matterStopCustomsFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-stop-customs-form>
   <matter-evidence-detection-form ref="matterEvidenceDetectionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-evidence-detection-form>
   <matter-mediation-form ref="matterMediationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-mediation-form>
   <matter-matter-info-form ref="matterMatterInfoFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-matter-info-form>
   <matter-legal-notice-form ref="matterLegalNoticeFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-legal-notice-form>
   <matter-simplified-destruction-form ref="matterSimplifiedDestructionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-simplified-destruction-form>
   <matter-legal-evidence-samples-form ref="matterLegalEvidenceSamplesFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-legal-evidence-samples-form>
   <matter-take-down-request-form ref="matterTakeDownRequestFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-take-down-request-form>
   <matter-professional-investigation-form ref="matterProfessionalInvestigationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-professional-investigation-form>
   <matter-security-deposit-form ref="matterSecurityDepositFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-security-deposit-form>
   <matter-monitoring-surveillance-form ref="matterMonitoringSurveillanceFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-monitoring-surveillance-form>
   <matter-trade-fair-form ref="matterTradeFairFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-trade-fair-form>
   <matter-criminal-complaint-form ref="matterCriminalComplaintFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList"></matter-criminal-complaint-form>
    <div class="d-flex justify-content-between align-items-center"  >
         <h4 class="card-title">{{ $t('others.process') }}</h4>
        <b-button style="border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" class="mb-2" @click="showModal()" >{{ $t('others.new_process') }}</b-button>
    </div>
   
  <vue-good-table 
      id="matterTypeHistoryTable"
      ref="matterTypeHistoryTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize" 
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" 
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'recordDate'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.record_date') }}
          </span>
           <span v-if="props.column.field === 'lawMatterTypeName'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.law_matter_process_type') }}
          </span>
            <span v-if="props.column.field === 'employeeName'" class="text-nowrap">
            {{ $t('lawMatterTypeHistory.employee') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.lawMatterTypeId,props.row.recordId,props.row.employeeId,props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', show: !hideDeleteButton, handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>   
</div>
</template>

<script>

export default {
    
    props:{
      lawMatterId: {type: Number},
      onOperationCreated: {type: Function}
    },
    watch: {
        lawMatterId(val) {
            if (val > 0) {
                this.getMatterTypeHistoryList()
            }
        }
    },
    data() {
        return {
            pageLength: 50,
            dir: false,
            isLoaded: false,
            columns: [
            {
                label: this.$t('lawMatterTypeHistory.record_date'),
                field: `recordDate`,
                formatFn: this.$formatFn
            },
            {
               label: this.$t('lawMatterTypeHistory.law_matter_process_type'),
               field: 'lawMatterTypeName'
            },
            {
               label: this.$t('lawMatterTypeHistory.employee'),
               field: 'employeeName'
            },
            {
                label: '',
                field: 'process',
                width: '10em',
                sortable: false
            },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    computed: {
    hideDeleteButton() {
      const id = localStorage.getItem('EmployeeId');
      if (['1','12','21'].includes(id)) // System Admin ve Ömer Dündar,Aysel Karaca
      return false
      return true
    },
  }, 
    mounted() {
        this.getMatterTypeHistoryList()
    },
    methods:{
        showModal(){
          this.$refs.matterAddMatterTypeModal.showInfo();
        },

        async getMatterTypeHistoryList(){

            if (!this.lawMatterId) return

            const wasLoaded = this.isLoaded
            const prevCount = this.rows.length
            const prevIds = this.rows.map(r => r.id)

           const controller = {name: 'LawMatterMatterTypeHistory',actionName: 'GetLawMatterMatterTypeHistoryListByLawMatterId'}
           this.rows = [];
            const data = {
                id: this.lawMatterId
            }
             const payload = {
                controller: controller,
                data: data
            }

            const response = await this.$store.dispatch('moduleAuth/customService', payload)

            if (response.data.resultStatus == true) {
                const newRows = response.data.lawMatterMatterTypeHistoryList || []
                this.rows = newRows
                this.isLoaded = true

                if (wasLoaded && newRows.length > prevCount && this.onOperationCreated) {
                    const newItem = newRows.find(r => !prevIds.includes(r.id))
                    if (newItem) {
                        await this.onOperationCreated(newRows.length, newItem.lawMatterTypeName, newItem.id, newItem.lawMatterTypeId)
                        await this.getMatterTypeHistoryList()
                    }
                }
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
        getInfo(lawMatterTypeId,recordId,employeeId,id){
            switch(lawMatterTypeId){
              case 1: this.$refs['matterMatterInfoFormModal'].showMatterInfo(recordId,this.lawMatterId); break;
              case 2: this.$refs['matterConsultingFormModal'].showConsulting(recordId,this.lawMatterId); break;
              case 3: this.$refs['matterCustomsRegistrationFormModal'].showCustomsRegistration(recordId,this.lawMatterId,employeeId); break;
              case 4: this.$refs['matterStopCustomsFormModal'].showStopCustoms(recordId,this.lawMatterId); break;
              case 5: this.$refs['matterEvidenceDetectionFormModal'].showEvidenceDetection(recordId,this.lawMatterId); break;
              case 7: this.$refs['matterSmugglingFormModal'].showSmuggling(recordId,this.lawMatterId); break;
              case 8: this.$refs['matterLegalNoticeFormModal'].showLegalNotice(recordId,this.lawMatterId); break;
              case 9: this.$refs['matterSimplifiedDestructionFormModal'].showSimplifiedDestruction(recordId,this.lawMatterId); break;
              case 10 : this.$refs['matterMediationFormModal'].showMediation(recordId,this.lawMatterId,employeeId,id); break;
              case 11: this.$refs['matterLegalEvidenceSamplesFormModal'].showLegalEvidenceSamples(recordId,this.lawMatterId); break;
              case 13 : this.$refs['matterTakeDownRequestFormModal'].showTakeDownRequest(recordId,this.lawMatterId,employeeId,id); break;
              case 15: this.$refs['matterMonitoringSurveillanceFormModal'].showMonitoringSurveillance(recordId,this.lawMatterId); break;
              case 17: this.$refs['matterSecurityDepositFormModal'].showSecurityDeposit(recordId,this.lawMatterId); break;
              case 19: this.$refs['matterProfessionalInvestigationFormModal'].showProfessionalInvestigation(recordId,this.lawMatterId); break;
              case 22: this.$refs['matterTradeFairFormModal'].showTradeFair(recordId,this.lawMatterId); break;
              case 27: this.$refs['matterDamagesClaimFormModal'].showDamagesClaim(recordId,this.lawMatterId); break;
              case 18: this.$refs['matterCriminalComplaintFormModal'].showCriminalComplaint(recordId,this.lawMatterId); break;
            }
        },
        async deleted(data) {

            data = {id: data.id}
            const controller = { name: 'LawMatterMatterTypeHistory'}
            const payload = {data: data, controller: controller }

            const result = await this.$DeleteConfirm()
                if (result.value) {
                    const response =  await this.$store.dispatch('moduleAuth/delete', payload)
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            await this.getMatterTypeHistoryList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            await this.getMatterTypeHistoryList()
                        }
                }

        }
    }
}
</script>

<style lang="scss">
</style>
